// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"32729678","37":"1f4cd6d6","174":"bc7380bd","209":"73f90cf5","242":"a92587de","435":"9ce9e711","497":"6d652304","562":"c1ba3671","602":"9cb09695","643":"f84642d6","830":"dcf69992","976":"53af902f"}[chunkId] + ".chunk.js";
};